export class ModeleFacturationLight {
    static jsonMap = {
        id: { key: 'id', optional: true },
        libelle: { key: 'libelle' },
        isGroupeOperateur: { key: 'isGroupeOperateur' }
    };

    id: number;
    libelle: string;
    isGroupeOperateur: boolean;
}
